/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Occupation_QuestionInputs */

const en_us2_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How physical is your work?`)
};

const pt_br2_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão físico é seu trabalho?`)
};

const es_419_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan físico es tu trabajo?`)
};

const pt_pt2_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão físico é o teu trabalho?`)
};

const fr_fr2_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton travail est-il physique ?`)
};

const de_de2_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie körperlich ist deine Arbeit?`)
};

const it_it2_improve_occupation_question = /** @type {(inputs: Improve_Occupation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è fisico il tuo lavoro?`)
};

/**
* | output |
* | --- |
* | "How physical is your work?" |
*
* @param {Improve_Occupation_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_occupation_question = /** @type {((inputs?: Improve_Occupation_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Occupation_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_occupation_question(inputs)
	if (locale === "es-419") return es_419_improve_occupation_question(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_occupation_question(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_occupation_question(inputs)
	if (locale === "de-DE") return de_de2_improve_occupation_question(inputs)
	if (locale === "it-IT") return it_it2_improve_occupation_question(inputs)
	return en_us2_improve_occupation_question(inputs)
});
export { improve_occupation_question as "improve.occupation.question" }